import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ChaseDetailState } from "../../../../chase-detail/chase-detail-state.model";
import { RiskDxDiagnosis } from "../dx-models/response/risk-dx-diagnosis.model";
import { RiskDxIcd } from "../dx-models/response/risk-dx-icd.model";


@Component({
  selector: "app-risk-dx-grid",
  templateUrl: "./dx-grid.component.html",
  styleUrls: ["./dx-grid.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DxGridComponent implements OnInit {
  @Input() diagnoses: RiskDxDiagnosis[] = [];
  @Input() disabled: boolean;
  @Input() icdGroup: RiskDxIcd;
  @Input() riskChaseState: ChaseDetailState;
  @Input() addNewDx: boolean;


  @Output() diagnosesChange: EventEmitter<RiskDxDiagnosis[]> = new EventEmitter();
  @Output() saveNewDiagnosis: EventEmitter<any> = new EventEmitter();
  @Output() removeDx: EventEmitter<any> = new EventEmitter();
  @Output() removeDiagnosis: EventEmitter<any> = new EventEmitter();
  constructor() {
  }

  ngOnInit(): void {
  }

  trackByIndex(index): number {
    return index;
  }

  saveDiagnosis($event) {
    this.saveNewDiagnosis.emit($event);
  }
  clearDiagnosis(): void {
    this.removeDx.emit();
  }
  removeCoderAddedDiagnosis(val) {
    this.removeDiagnosis.emit(val);
  }
}
